import React from "react";
import { oneOfType, arrayOf, node, shape, string, oneOf } from "prop-types";
import { RouterLink, HtmlLink } from "./styles";
import colours from "assets/colours";

const Link = ({ to, href, target, rel, children, variant, ...rest }) => {
  const attributes = { to, href, target, rel, variant, ...rest };
  const Component = to ? RouterLink : HtmlLink;
  return <Component {...attributes}>{children}</Component>;
};

export default Link;

Link.defaultProps = {
  href: "",
  to: "",
  target: "_self",
  rel: "",
  variant: "",
  styles: {},
};

Link.propTypes = {
  to: string,
  children: oneOfType([arrayOf(node), node]).isRequired,
  target: oneOf(["_blank", "_self", "_parent", "_top"]),
  rel: string,
  variant: oneOf(["", ...Object.keys(colours)]),
  styles: shape({}),
};
